module.exports = __webpack_public_path__ + "ipetbooking/admin/img/chailease.464aadef.png";